<template>
    <div :class="{'has-logo':showLogo}" style="border-radius:0;">
        <logo v-if="showLogo" :collapse="isCollapse" />
        <el-scrollbar wrap-class="scrollbar-wrapper" :class="settings.sideTheme">
            <el-menu
                    :default-active="activeMenu"
                    :collapse="isCollapse"
                    :text-color="settings.sideTheme | textColorFilter(textColor)"
                    :unique-opened="true"
                    active-text-color="#FFF"
                    :collapse-transition="false"
                    mode="vertical"
            >
                <sidebar-item
                        v-for="(route, index) in sidebarRouters"
                        :key="route.code  + index"
                        :item="route"
                        :collapse="isCollapse"
                        :base-path="route.code"
                />
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/assets/styles/variables.scss";

export default {
    data() {
        return {
            textColor:{
                "theme-blue":"#FFF",
                "theme-dark":"#FFF",
                "theme-light":"#333",
                "theme-green":'#333'
            },
            textColorA:{
                "theme-blue":"#FFF",
                "theme-dark":"#FFF",
                "theme-light":"#579cf6",
            },
        }
    },
    components: { SidebarItem, Logo },
    computed: {
        ...mapState(["settings"]),
        ...mapGetters(["sidebarRouters", "sidebar"]),
        activeMenu() {
            const route = this.$route;
            const { meta, path } = route;
            // if set path, the sidebar will highlight the path you set
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
        showLogo() {
            return this.$store.state.settings.sidebarLogo;
        },
        variables() {
            return variables;
        },
        isCollapse() {
            return !this.sidebar.opened;
        }
    },
    filters:{
        textColorFilter:function (value,textColor){
            return textColor[value]
        },
        textColorActiveFilter:function (value,textColorA){
            return textColorA[value]
        }
    },
};
</script>
<style lang="stylus">
.theme-blue{
  background-color: #579cf6;
  .el-submenu__icon-arrow{
    color:#FFF;
  }
  .iconList1 {
    height: 30px;
    width: 30px;
    margin-right: 4px;
    vertical-align: -10px;
  }
  .iconList2 {
    height: 20px;
    width: 20px;
    margin-right: 4px;
    vertical-align: -5px;
  }
  .el-menu-item {
    &:hover {
      background-color: #000 !important;
    }
  }
  .el-menu-item.is-active {
    background-color: #0b4986 !important;
    //border-right: 4px solid #1890ff !important;
  }
}
</style>
